/**
 * Core global JS.
 */

// Utils
import { ComponentManager } from 'js-component-framework';
import domContentLoaded from 'utils/domContentLoaded';

// Global styles.
import 'scss/index.scss';

// Components.
import menuButtonConfig from 'components/global-header';
import counterBoxConfig from 'components/counter-box';
import circularCounterConfig from 'components/circular-counter';
import tabListConfig from 'components/tab-list';
import headingShareConfig from 'components/heading-share';

// Web Components.
import 'web-components/accordion-item';
import 'web-components/ai-carousel';

// Modules.
import 'components/featured-image';
import 'components/entry-content';
import 'components/page-header';
import 'components/social-links';
import 'components/contact-button';
import 'components/global-footer';
import 'components/pagination';
import 'components/post-item';
import 'components/search-form';

// Create instance of the component manager.
const manager = new ComponentManager('atsls');

// Initialize components
domContentLoaded(() => {
  manager.initComponents([
    menuButtonConfig,
    tabListConfig,
    counterBoxConfig,
    circularCounterConfig,
    headingShareConfig,
  ]);
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes

  manager.initComponents([
    menuButtonConfig,
    tabListConfig,
    counterBoxConfig,
    circularCounterConfig,
    headingShareConfig,
  ]);
}
